/**
 * Minimal GraphQL client for the public lead-capture mutations on tzilla-be.
 * No auth: the marketing site posts anonymously; the backend rate-limits
 * unauthenticated GraphQL per IP.
 */
const DEFAULT_ENDPOINT = 'https://api.tzilla.live/graphql';

export const GRAPHQL_ENDPOINT: string =
  ((import.meta as any).env?.VITE_TZILLA_API_URL as string | undefined) || DEFAULT_ENDPOINT;

type GqlError = { message?: string };

export async function gqlRequest<T>(query: string, variables: Record<string, unknown>): Promise<T> {
  const res = await fetch(GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  });

  let body: { data?: T; errors?: GqlError[] } | null = null;
  try {
    body = await res.json();
  } catch {
    // fall through to the status error below
  }

  if (body?.errors?.length) {
    throw new Error(body.errors[0]?.message || 'Request failed');
  }
  if (!res.ok || !body?.data) {
    throw new Error(res.status === 429 ? 'Too many requests — please try again in a minute.' : `Request failed (${res.status})`);
  }
  return body.data;
}
